import React, { Fragment } from "react";

export default ({ data }) => {
  let show = false;

  const ul = (
    <ul>
      {data.map((item, index) => {
        if (item.description) {
          show = true;
        }
        return (
          item.description && (
            <li key={index}>
              A <b>{item.name}</b> donation {item.description}
            </li>
          )
        );
      })}
    </ul>
  );

  return show ? (
    <Fragment>
      <h3 style={{ marginTop: "25px" }}>Suggested Donations</h3>
      {ul}
    </Fragment>
  ) : (
    <Fragment />
  );
};
